<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label>Finalização Receita</label>
                  <input
                    type="text"
                    id="finalizacao"
                    class="form-control"
                    v-model="finalizacao_receita.nome"
                  />
                </div>
                <div class="col-md-12">
                  <label>Descrição</label>
                  <textarea
                    cols="30"
                    rows="10"
                    class="form-control"
                    v-model="finalizacao_receita.descricao"
                  ></textarea>
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link
                    to="/finalizacao_receitas"
                    class="btn btn-back mr-1"
                  >
                    <i class="fa fa-arrow-left" />
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      finalizacao_receita: {},
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "finalizacao_receitas";

      self.$loading(true);

      if (self.finalizacao_receita.id) {
        api += "/" + self.finalizacao_receita.id;
        self.finalizacao_receita._method = "PUT";
      }

      axios
        .post(api, self.finalizacao_receita)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/finalizacao_receitas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getFinalizacaoReceita: function (id) {
      const self = this;
      const api = self.$store.state.api + "finalizacao_receitas/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.finalizacao_receita = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
  },
  mounted: function () {
    const self = this;
    $("#finalizacao").focus();

    let id = self.$route.params.id;
    if (id) {
      self.getFinalizacaoReceita(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>